export const FETCH_COMPANIES = "FETCH_COMPANIES";
export const FETCH_COMPANY = "FETCH_COMPANY";
